import { takeEvery, put, call, select, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';
import { updateDiscipleByMap } from 'src/components/therapyPlanning_2.0/commonComponent/updateSingleCellData';
import moment from 'moment';

const {
  EDIT_SINGLE_CELL_THERAPY_PLANNING_REQUEST,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_SUCCESS,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_FAILURE,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_RESET,
  EDIT_SINGLE_CELL_THERAPY_PLANNING_LOADING,
  GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
  GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
  GET_7DAY_LOOK_BACK_SUM_REQUEST,
  ADD_SINGLE_THERAPY_PLANNING_2_0,
} = therapyPlanningAction;

function* editSingleCellOfTherapyFunction(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: EDIT_SINGLE_CELL_THERAPY_PLANNING_LOADING });
    const response = yield call(
      therapyPlanningService.editSingleCellOfTherapyPlanning,
      payload?.payload
    );
    if (response?.status === 200) {
      // Guard: if patient changed during the edit API call, discard the response
      // to prevent the refresh chain from merging stale data into the new patient's view
      const currentPatientUuid: string = yield select(
        (state: any) => state?.selectPatientReducer?.patientInfo?.uuid
      );
      if (payload?.payload?.patientId !== currentPatientUuid) {
        return;
      }
      yield put({
        type: EDIT_SINGLE_CELL_THERAPY_PLANNING_SUCCESS,
        payload: {
          response: response.data,
          requestedPayload: {
            patientId: payload?.payload?.patientId,
            // abortToken: therapyPlanningAbort.token,
            therapyType: payload?.payload?.params?.discipline,
            groupType: payload?.payload?.params?.type,
            source: 'GET_SINGLE_CELL',
            params: {
              providerId: payload?.payload?.providerId,
              startDate: payload?.payload?.params?.localDate,
              endDate: payload?.payload?.params?.localDate,
            },
          },
        },
      });
      //call get api's for single cell
      yield put({
        type: GET_DATA_THERAPY_PLANNING_REQUEST_2_0,
        payload: {
          patientId: payload?.payload?.patientId,
          // abortToken: therapyPlanningAbort.token,
          therapyType: payload?.payload?.params?.discipline,
          groupType: payload?.payload?.params?.type,
          source: 'GET_SINGLE_CELL',
          params: {
            providerId: payload?.payload?.providerId,
            startDate: payload?.payload?.params?.localDate,
            endDate: payload?.payload?.params?.localDate,
          },
        },
      });

      //add single data
      // yield put({
      //   type: ADD_SINGLE_THERAPY_PLANNING_2_0,
      //   payload: {
      //     therapyType: updateDiscipleByMap(payload?.payload?.params?.discipline),
      //     groupType: payload?.payload?.params?.type,
      //     localDate: payload?.payload?.params?.localDate,
      //     planMinutes: payload?.payload?.params?.planMinutes,
      //   },
      // });

      yield put({
        type: GET_THERAPY_PLANNING_SUMMARY_REQUEST_2_0,
        payload: {
          patientId: payload?.payload?.patientId,
          // abortToken: therapyPlanningAbort.token,
          therapyType: payload?.payload?.params?.discipline,
          groupType: payload?.payload?.params?.type,
          source: 'GET_SINGLE_CELL',
          params: {
            providerId: payload?.payload?.providerId,
            startDate: payload?.payload?.weekStartDate,
            endDate: payload?.payload?.weekEndDate,
            discipline: payload?.payload?.params?.discipline,
          },
        },
      });
      yield put({
        type: GET_7DAY_LOOK_BACK_SUM_REQUEST,
        payload: {
          patientId: payload?.payload?.patientId,
          // abortToken: therapyPlanningAbort.token,
          therapyType: payload?.payload?.params?.discipline,
          groupType: payload?.payload?.params?.type,
          source: 'GET_SINGLE_CELL',
          params: {
            providerId: payload?.payload?.providerId,
            startDate: payload?.payload?.weekStartDate,
            endDate: payload?.payload?.weekEndDate,
            discipline: payload?.payload?.params?.discipline,
            today: moment().format('YYYY-MM-DD'),
          },
        },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: EDIT_SINGLE_CELL_THERAPY_PLANNING_FAILURE, payload: error });
  }
}

function* editSingleCellTherapyPlanningSaga() {
  yield takeEvery(EDIT_SINGLE_CELL_THERAPY_PLANNING_REQUEST, editSingleCellOfTherapyFunction);
}

export default editSingleCellTherapyPlanningSaga;
